import {
	COMPLAINT_CHANNEL_OPTIONS,
	COMPLAINT_SYSTEM_PLATFORM_OPTIONS,
	type COMPLAINT_SYSTEM_USAGE_OPTIONS,
} from '#app/routes/mocra+/_form+/intake-options.ts'

export type ComplaintSystemPlatformValue =
	(typeof COMPLAINT_SYSTEM_PLATFORM_OPTIONS)[number]['value']

export type AutofillPlatformValue = Exclude<
	ComplaintSystemPlatformValue,
	'custom' | 'other'
>

export const CHANNEL_CARD_OPTIONS = COMPLAINT_CHANNEL_OPTIONS

export const COMPLAINT_CHANNEL_VALUE_SET = new Set(
	COMPLAINT_CHANNEL_OPTIONS.map((option) => option.value),
)

export const PLATFORM_AUTOFILL_LABELS = new Map<AutofillPlatformValue, string>(
	COMPLAINT_SYSTEM_PLATFORM_OPTIONS.filter(
		(option) => option.value !== 'custom' && option.value !== 'other',
	).map((option) => [option.value as AutofillPlatformValue, option.label]),
)

export function toAutofillPlatformValue(
	value: unknown,
): AutofillPlatformValue | null {
	if (typeof value !== 'string') return null
	if (value === 'custom' || value === 'other') return null
	return COMPLAINT_SYSTEM_PLATFORM_OPTIONS.some(
		(option) => option.value === value,
	)
		? (value as AutofillPlatformValue)
		: null
}

export function coerceBoolean(value: unknown): boolean {
	if (typeof value === 'boolean') return value
	if (typeof value === 'number') return value === 1
	if (typeof value === 'string') {
		const normalized = value.toLowerCase()
		return normalized === 'true' || normalized === 'on' || normalized === '1'
	}
	return false
}

export const COMPLAINT_SYSTEM_USAGE_DESCRIPTIONS: Record<
	(typeof COMPLAINT_SYSTEM_USAGE_OPTIONS)[number]['value'],
	string
> = {
	intake:
		'Logs new complaints as they arrive, captures required facts, and routes them for follow-up.',
	case_management:
		'Tracks investigation workflow, ownership, corrections, and closure activities.',
	master_log:
		'Maintains the canonical complaint register used for audits and FDA reporting.',
	analytics:
		'Surfaces trends, spikes, and metrics for ongoing complaint analytics.',
}
